var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c("h2", [_vm._v("input的使用")]),
      _vm._v(" "),
      _c("p", [_vm._v("主要用于数据收集、校验和提交功能的表单")]),
      _vm._v(" "),
      _c("h2", [_vm._v("textarea的使用")]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("h4", [_vm._v("textarea和input的引入方式")]),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _c("h3", [_vm._v("何时使用")]),
      _vm._v(" "),
      _vm._m(2),
      _vm._v(" "),
      _c("h3", [_vm._v("代码演示")]),
      _vm._v(" "),
      _c("h4", [_vm._v("效果展示")]),
      _vm._v(" "),
      _c("demo-block", [
        _c(
          "div",
          { staticClass: "source", attrs: { slot: "source" }, slot: "source" },
          [
            [
              _c("div", { staticClass: "form" }, [
                _c(
                  "div",
                  { staticClass: "form-item" },
                  [
                    _c("label", { attrs: { for: "name" } }, [_vm._v("姓名:")]),
                    _vm._v(" "),
                    _c("mi-vant-input", {
                      attrs: {
                        label: _vm.form.name.label,
                        "label-key": _vm.form.name.labelKey,
                        placeholder: _vm.form.name.placeholder,
                        required: _vm.form.name.required,
                        "valiedate-message": _vm.form.name.valiedateMessage,
                        "error-status": _vm.form.name.errorStatus
                      },
                      on: { getFieldsError: _vm.errorCollect },
                      model: {
                        value: _vm.form.name.value,
                        callback: function($$v) {
                          _vm.$set(_vm.form.name, "value", $$v)
                        },
                        expression: "form.name.value"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-item" },
                  [
                    _c("label", { attrs: { for: "telephone" } }, [
                      _vm._v("手机号:")
                    ]),
                    _vm._v(" "),
                    _c("mi-vant-input", {
                      attrs: {
                        label: _vm.form.phone.label,
                        "label-key": _vm.form.phone.labelKey,
                        placeholder: _vm.form.phone.placeholder,
                        required: _vm.form.phone.required,
                        "valiedate-message": _vm.form.phone.valiedateMessage,
                        "error-status": _vm.form.phone.errorStatus,
                        "hanle-validate": _vm.hanleValidate
                      },
                      on: { getFieldsError: _vm.errorCollect },
                      model: {
                        value: _vm.form.phone.value,
                        callback: function($$v) {
                          _vm.$set(_vm.form.phone, "value", $$v)
                        },
                        expression: "form.phone.value"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-item" },
                  [
                    _c("label", { attrs: { for: "telephone" } }, [
                      _vm._v("我的梦想:")
                    ]),
                    _vm._v(" "),
                    _c("mi-vant-textarea", {
                      attrs: {
                        label: _vm.form.dream.label,
                        "label-key": _vm.form.dream.labelKey,
                        placeholder: _vm.form.dream.placeholder,
                        required: _vm.form.dream.required,
                        "valiedate-message": _vm.form.dream.valiedateMessage,
                        "error-status": _vm.form.dream.errorStatus
                      },
                      on: { getFieldsError: _vm.errorCollect },
                      model: {
                        value: _vm.form.dream.value,
                        callback: function($$v) {
                          _vm.$set(_vm.form.dream, "value", $$v)
                        },
                        expression: "form.dream.value"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-item" },
                  [
                    _c("label", { attrs: { for: "telephone" } }, [
                      _vm._v("合伙人宣言:")
                    ]),
                    _vm._v(" "),
                    _c("mi-vant-textarea", {
                      attrs: {
                        label: _vm.form.declaration.label,
                        "label-key": _vm.form.declaration.labelKey,
                        placeholder: _vm.form.declaration.placeholder,
                        length: _vm.form.declaration.length,
                        required: _vm.form.declaration.required,
                        "valiedate-message":
                          _vm.form.declaration.valiedateMessage,
                        "error-status": _vm.form.declaration.errorStatus
                      },
                      on: { getFieldsError: _vm.errorCollect },
                      model: {
                        value: _vm.form.declaration.value,
                        callback: function($$v) {
                          _vm.$set(_vm.form.declaration, "value", $$v)
                        },
                        expression: "form.declaration.value"
                      }
                    })
                  ],
                  1
                )
              ])
            ]
          ],
          2
        ),
        _vm._v(" "),
        _c("p", [_vm._v("禁用")]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "highlight",
            attrs: { slot: "highlight" },
            slot: "highlight"
          },
          [
            _c("pre", { pre: true }, [
              _c("code", { attrs: { "v-pre": "", class: "language-html" } }, [
                _c("span", { attrs: { class: "hljs-tag" } }, [
                  _vm._v("<"),
                  _c("span", { attrs: { class: "hljs-name" } }, [
                    _vm._v("template")
                  ]),
                  _vm._v(">")
                ]),
                _vm._v("\n"),
                _c("span", { attrs: { class: "hljs-tag" } }, [
                  _vm._v("<"),
                  _c("span", { attrs: { class: "hljs-name" } }, [
                    _vm._v("div")
                  ]),
                  _vm._v(" "),
                  _c("span", { attrs: { class: "hljs-attr" } }, [
                    _vm._v("class")
                  ]),
                  _vm._v("="),
                  _c("span", { attrs: { class: "hljs-string" } }, [
                    _vm._v('"form"')
                  ]),
                  _vm._v(">")
                ]),
                _vm._v("\n          "),
                _c("span", { attrs: { class: "hljs-tag" } }, [
                  _vm._v("<"),
                  _c("span", { attrs: { class: "hljs-name" } }, [
                    _vm._v("div")
                  ]),
                  _vm._v(" "),
                  _c("span", { attrs: { class: "hljs-attr" } }, [
                    _vm._v("class")
                  ]),
                  _vm._v("="),
                  _c("span", { attrs: { class: "hljs-string" } }, [
                    _vm._v('"form-item"')
                  ]),
                  _vm._v(">")
                ]),
                _vm._v("\n              "),
                _c("span", { attrs: { class: "hljs-tag" } }, [
                  _vm._v("<"),
                  _c("span", { attrs: { class: "hljs-name" } }, [
                    _vm._v("label")
                  ]),
                  _vm._v(" "),
                  _c("span", { attrs: { class: "hljs-attr" } }, [
                    _vm._v("for")
                  ]),
                  _vm._v("="),
                  _c("span", { attrs: { class: "hljs-string" } }, [
                    _vm._v('"name"')
                  ]),
                  _vm._v(">")
                ]),
                _vm._v("姓名:"),
                _c("span", { attrs: { class: "hljs-tag" } }, [
                  _vm._v("</"),
                  _c("span", { attrs: { class: "hljs-name" } }, [
                    _vm._v("label")
                  ]),
                  _vm._v(">")
                ]),
                _vm._v("\n              "),
                _c("span", { attrs: { class: "hljs-tag" } }, [
                  _vm._v("<"),
                  _c("span", { attrs: { class: "hljs-name" } }, [
                    _vm._v("mi-vant-input")
                  ]),
                  _vm._v("\n                  "),
                  _c("span", { attrs: { class: "hljs-attr" } }, [
                    _vm._v(":label")
                  ]),
                  _vm._v("="),
                  _c("span", { attrs: { class: "hljs-string" } }, [
                    _vm._v('"form.name.label"')
                  ]),
                  _vm._v("\n                  "),
                  _c("span", { attrs: { class: "hljs-attr" } }, [
                    _vm._v(":label-key")
                  ]),
                  _vm._v("="),
                  _c("span", { attrs: { class: "hljs-string" } }, [
                    _vm._v('"form.name.labelKey"')
                  ]),
                  _vm._v("\n                  "),
                  _c("span", { attrs: { class: "hljs-attr" } }, [
                    _vm._v(":placeholder")
                  ]),
                  _vm._v("="),
                  _c("span", { attrs: { class: "hljs-string" } }, [
                    _vm._v('"form.name.placeholder"')
                  ]),
                  _vm._v("\n                  "),
                  _c("span", { attrs: { class: "hljs-attr" } }, [
                    _vm._v("v-model")
                  ]),
                  _vm._v("="),
                  _c("span", { attrs: { class: "hljs-string" } }, [
                    _vm._v("'form.name.value'")
                  ]),
                  _vm._v("\n                  "),
                  _c("span", { attrs: { class: "hljs-attr" } }, [
                    _vm._v(":required")
                  ]),
                  _vm._v("="),
                  _c("span", { attrs: { class: "hljs-string" } }, [
                    _vm._v("'form.name.required'")
                  ]),
                  _vm._v("\n                  "),
                  _c("span", { attrs: { class: "hljs-attr" } }, [
                    _vm._v(":valiedate-message")
                  ]),
                  _vm._v("="),
                  _c("span", { attrs: { class: "hljs-string" } }, [
                    _vm._v('"form.name.valiedateMessage"')
                  ]),
                  _vm._v("\n                  "),
                  _c("span", { attrs: { class: "hljs-attr" } }, [
                    _vm._v(":error-status")
                  ]),
                  _vm._v("="),
                  _c("span", { attrs: { class: "hljs-string" } }, [
                    _vm._v("'form.name.errorStatus'")
                  ]),
                  _vm._v("\n                  "),
                  _c("span", { attrs: { class: "hljs-attr" } }, [
                    _vm._v("@getFieldsError")
                  ]),
                  _vm._v("="),
                  _c("span", { attrs: { class: "hljs-string" } }, [
                    _vm._v('"errorCollect"')
                  ]),
                  _vm._v("\n              />")
                ]),
                _vm._v("\n          "),
                _c("span", { attrs: { class: "hljs-tag" } }, [
                  _vm._v("</"),
                  _c("span", { attrs: { class: "hljs-name" } }, [
                    _vm._v("div")
                  ]),
                  _vm._v(">")
                ]),
                _vm._v("\n          "),
                _c("span", { attrs: { class: "hljs-tag" } }, [
                  _vm._v("<"),
                  _c("span", { attrs: { class: "hljs-name" } }, [
                    _vm._v("div")
                  ]),
                  _vm._v(" "),
                  _c("span", { attrs: { class: "hljs-attr" } }, [
                    _vm._v("class")
                  ]),
                  _vm._v("="),
                  _c("span", { attrs: { class: "hljs-string" } }, [
                    _vm._v('"form-item"')
                  ]),
                  _vm._v(">")
                ]),
                _vm._v("\n              "),
                _c("span", { attrs: { class: "hljs-tag" } }, [
                  _vm._v("<"),
                  _c("span", { attrs: { class: "hljs-name" } }, [
                    _vm._v("label")
                  ]),
                  _vm._v(" "),
                  _c("span", { attrs: { class: "hljs-attr" } }, [
                    _vm._v("for")
                  ]),
                  _vm._v("="),
                  _c("span", { attrs: { class: "hljs-string" } }, [
                    _vm._v('"telephone"')
                  ]),
                  _vm._v(">")
                ]),
                _vm._v("手机号:"),
                _c("span", { attrs: { class: "hljs-tag" } }, [
                  _vm._v("</"),
                  _c("span", { attrs: { class: "hljs-name" } }, [
                    _vm._v("label")
                  ]),
                  _vm._v(">")
                ]),
                _vm._v("\n              "),
                _c("span", { attrs: { class: "hljs-tag" } }, [
                  _vm._v("<"),
                  _c("span", { attrs: { class: "hljs-name" } }, [
                    _vm._v("mi-vant-input")
                  ]),
                  _vm._v("\n                  "),
                  _c("span", { attrs: { class: "hljs-attr" } }, [
                    _vm._v(":label")
                  ]),
                  _vm._v("="),
                  _c("span", { attrs: { class: "hljs-string" } }, [
                    _vm._v('"form.phone.label"')
                  ]),
                  _vm._v("\n                  "),
                  _c("span", { attrs: { class: "hljs-attr" } }, [
                    _vm._v(":label-key")
                  ]),
                  _vm._v("="),
                  _c("span", { attrs: { class: "hljs-string" } }, [
                    _vm._v('"form.phone.labelKey"')
                  ]),
                  _vm._v("\n                  "),
                  _c("span", { attrs: { class: "hljs-attr" } }, [
                    _vm._v(":placeholder")
                  ]),
                  _vm._v("="),
                  _c("span", { attrs: { class: "hljs-string" } }, [
                    _vm._v('"form.phone.placeholder"')
                  ]),
                  _vm._v("\n                  "),
                  _c("span", { attrs: { class: "hljs-attr" } }, [
                    _vm._v("v-model")
                  ]),
                  _vm._v("="),
                  _c("span", { attrs: { class: "hljs-string" } }, [
                    _vm._v("'form.phone.value'")
                  ]),
                  _vm._v("\n                  "),
                  _c("span", { attrs: { class: "hljs-attr" } }, [
                    _vm._v(":required")
                  ]),
                  _vm._v("="),
                  _c("span", { attrs: { class: "hljs-string" } }, [
                    _vm._v("'form.phone.required'")
                  ]),
                  _vm._v("\n                  "),
                  _c("span", { attrs: { class: "hljs-attr" } }, [
                    _vm._v(":valiedate-message")
                  ]),
                  _vm._v("="),
                  _c("span", { attrs: { class: "hljs-string" } }, [
                    _vm._v('"form.phone.valiedateMessage"')
                  ]),
                  _vm._v("\n                  "),
                  _c("span", { attrs: { class: "hljs-attr" } }, [
                    _vm._v(":error-status")
                  ]),
                  _vm._v("="),
                  _c("span", { attrs: { class: "hljs-string" } }, [
                    _vm._v("'form.phone.errorStatus'")
                  ]),
                  _vm._v("\n                  "),
                  _c("span", { attrs: { class: "hljs-attr" } }, [
                    _vm._v(":hanle-validate")
                  ]),
                  _vm._v("="),
                  _c("span", { attrs: { class: "hljs-string" } }, [
                    _vm._v("'hanleValidate'")
                  ]),
                  _vm._v("\n                  "),
                  _c("span", { attrs: { class: "hljs-attr" } }, [
                    _vm._v("@getFieldsError")
                  ]),
                  _vm._v("="),
                  _c("span", { attrs: { class: "hljs-string" } }, [
                    _vm._v('"errorCollect"')
                  ]),
                  _vm._v("\n              />")
                ]),
                _vm._v("\n          "),
                _c("span", { attrs: { class: "hljs-tag" } }, [
                  _vm._v("</"),
                  _c("span", { attrs: { class: "hljs-name" } }, [
                    _vm._v("div")
                  ]),
                  _vm._v(">")
                ]),
                _vm._v("\n          "),
                _c("span", { attrs: { class: "hljs-tag" } }, [
                  _vm._v("<"),
                  _c("span", { attrs: { class: "hljs-name" } }, [
                    _vm._v("div")
                  ]),
                  _vm._v(" "),
                  _c("span", { attrs: { class: "hljs-attr" } }, [
                    _vm._v("class")
                  ]),
                  _vm._v("="),
                  _c("span", { attrs: { class: "hljs-string" } }, [
                    _vm._v('"form-item"')
                  ]),
                  _vm._v(">")
                ]),
                _vm._v("\n              "),
                _c("span", { attrs: { class: "hljs-tag" } }, [
                  _vm._v("<"),
                  _c("span", { attrs: { class: "hljs-name" } }, [
                    _vm._v("label")
                  ]),
                  _vm._v(" "),
                  _c("span", { attrs: { class: "hljs-attr" } }, [
                    _vm._v("for")
                  ]),
                  _vm._v("="),
                  _c("span", { attrs: { class: "hljs-string" } }, [
                    _vm._v('"telephone"')
                  ]),
                  _vm._v(">")
                ]),
                _vm._v("我的梦想:"),
                _c("span", { attrs: { class: "hljs-tag" } }, [
                  _vm._v("</"),
                  _c("span", { attrs: { class: "hljs-name" } }, [
                    _vm._v("label")
                  ]),
                  _vm._v(">")
                ]),
                _vm._v("\n              "),
                _c("span", { attrs: { class: "hljs-tag" } }, [
                  _vm._v("<"),
                  _c("span", { attrs: { class: "hljs-name" } }, [
                    _vm._v("mi-vant-textarea")
                  ]),
                  _vm._v("\n                  "),
                  _c("span", { attrs: { class: "hljs-attr" } }, [
                    _vm._v(":label")
                  ]),
                  _vm._v("="),
                  _c("span", { attrs: { class: "hljs-string" } }, [
                    _vm._v('"form.dream.label"')
                  ]),
                  _vm._v("\n                  "),
                  _c("span", { attrs: { class: "hljs-attr" } }, [
                    _vm._v(":label-key")
                  ]),
                  _vm._v("="),
                  _c("span", { attrs: { class: "hljs-string" } }, [
                    _vm._v('"form.dream.labelKey"')
                  ]),
                  _vm._v("\n                  "),
                  _c("span", { attrs: { class: "hljs-attr" } }, [
                    _vm._v(":placeholder")
                  ]),
                  _vm._v("="),
                  _c("span", { attrs: { class: "hljs-string" } }, [
                    _vm._v('"form.dream.placeholder"')
                  ]),
                  _vm._v("\n                  "),
                  _c("span", { attrs: { class: "hljs-attr" } }, [
                    _vm._v("v-model")
                  ]),
                  _vm._v("="),
                  _c("span", { attrs: { class: "hljs-string" } }, [
                    _vm._v("'form.dream.value'")
                  ]),
                  _vm._v("\n                  "),
                  _c("span", { attrs: { class: "hljs-attr" } }, [
                    _vm._v(":required")
                  ]),
                  _vm._v("="),
                  _c("span", { attrs: { class: "hljs-string" } }, [
                    _vm._v("'form.dream.required'")
                  ]),
                  _vm._v("\n                  "),
                  _c("span", { attrs: { class: "hljs-attr" } }, [
                    _vm._v(":valiedate-message")
                  ]),
                  _vm._v("="),
                  _c("span", { attrs: { class: "hljs-string" } }, [
                    _vm._v('"form.dream.valiedateMessage"')
                  ]),
                  _vm._v("\n                  "),
                  _c("span", { attrs: { class: "hljs-attr" } }, [
                    _vm._v(":error-status")
                  ]),
                  _vm._v("="),
                  _c("span", { attrs: { class: "hljs-string" } }, [
                    _vm._v("'form.dream.errorStatus'")
                  ]),
                  _vm._v("\n                  "),
                  _c("span", { attrs: { class: "hljs-attr" } }, [
                    _vm._v("@getFieldsError")
                  ]),
                  _vm._v("="),
                  _c("span", { attrs: { class: "hljs-string" } }, [
                    _vm._v('"errorCollect"')
                  ]),
                  _vm._v("\n              />")
                ]),
                _vm._v("\n          "),
                _c("span", { attrs: { class: "hljs-tag" } }, [
                  _vm._v("</"),
                  _c("span", { attrs: { class: "hljs-name" } }, [
                    _vm._v("div")
                  ]),
                  _vm._v(">")
                ]),
                _vm._v("\n          "),
                _c("span", { attrs: { class: "hljs-tag" } }, [
                  _vm._v("<"),
                  _c("span", { attrs: { class: "hljs-name" } }, [
                    _vm._v("div")
                  ]),
                  _vm._v(" "),
                  _c("span", { attrs: { class: "hljs-attr" } }, [
                    _vm._v("class")
                  ]),
                  _vm._v("="),
                  _c("span", { attrs: { class: "hljs-string" } }, [
                    _vm._v('"form-item"')
                  ]),
                  _vm._v(">")
                ]),
                _vm._v("\n              "),
                _c("span", { attrs: { class: "hljs-tag" } }, [
                  _vm._v("<"),
                  _c("span", { attrs: { class: "hljs-name" } }, [
                    _vm._v("label")
                  ]),
                  _vm._v(" "),
                  _c("span", { attrs: { class: "hljs-attr" } }, [
                    _vm._v("for")
                  ]),
                  _vm._v("="),
                  _c("span", { attrs: { class: "hljs-string" } }, [
                    _vm._v('"telephone"')
                  ]),
                  _vm._v(">")
                ]),
                _vm._v("合伙人宣言:"),
                _c("span", { attrs: { class: "hljs-tag" } }, [
                  _vm._v("</"),
                  _c("span", { attrs: { class: "hljs-name" } }, [
                    _vm._v("label")
                  ]),
                  _vm._v(">")
                ]),
                _vm._v("\n              "),
                _c("span", { attrs: { class: "hljs-tag" } }, [
                  _vm._v("<"),
                  _c("span", { attrs: { class: "hljs-name" } }, [
                    _vm._v("mi-vant-textarea")
                  ]),
                  _vm._v("\n                  "),
                  _c("span", { attrs: { class: "hljs-attr" } }, [
                    _vm._v(":label")
                  ]),
                  _vm._v("="),
                  _c("span", { attrs: { class: "hljs-string" } }, [
                    _vm._v('"form.declaration.label"')
                  ]),
                  _vm._v("\n                  "),
                  _c("span", { attrs: { class: "hljs-attr" } }, [
                    _vm._v(":label-key")
                  ]),
                  _vm._v("="),
                  _c("span", { attrs: { class: "hljs-string" } }, [
                    _vm._v('"form.declaration.labelKey"')
                  ]),
                  _vm._v("\n                  "),
                  _c("span", { attrs: { class: "hljs-attr" } }, [
                    _vm._v(":placeholder")
                  ]),
                  _vm._v("="),
                  _c("span", { attrs: { class: "hljs-string" } }, [
                    _vm._v('"form.declaration.placeholder"')
                  ]),
                  _vm._v("\n                  "),
                  _c("span", { attrs: { class: "hljs-attr" } }, [
                    _vm._v("v-model")
                  ]),
                  _vm._v("="),
                  _c("span", { attrs: { class: "hljs-string" } }, [
                    _vm._v("'form.declaration.value'")
                  ]),
                  _vm._v("\n                  "),
                  _c("span", { attrs: { class: "hljs-attr" } }, [
                    _vm._v(":length")
                  ]),
                  _vm._v("="),
                  _c("span", { attrs: { class: "hljs-string" } }, [
                    _vm._v("'form.declaration.length'")
                  ]),
                  _vm._v("\n                  "),
                  _c("span", { attrs: { class: "hljs-attr" } }, [
                    _vm._v(":required")
                  ]),
                  _vm._v("="),
                  _c("span", { attrs: { class: "hljs-string" } }, [
                    _vm._v("'form.declaration.required'")
                  ]),
                  _vm._v("\n                  "),
                  _c("span", { attrs: { class: "hljs-attr" } }, [
                    _vm._v(":valiedate-message")
                  ]),
                  _vm._v("="),
                  _c("span", { attrs: { class: "hljs-string" } }, [
                    _vm._v('"form.declaration.valiedateMessage"')
                  ]),
                  _vm._v("\n                  "),
                  _c("span", { attrs: { class: "hljs-attr" } }, [
                    _vm._v(":error-status")
                  ]),
                  _vm._v("="),
                  _c("span", { attrs: { class: "hljs-string" } }, [
                    _vm._v("'form.declaration.errorStatus'")
                  ]),
                  _vm._v("\n                  "),
                  _c("span", { attrs: { class: "hljs-attr" } }, [
                    _vm._v("@getFieldsError")
                  ]),
                  _vm._v("="),
                  _c("span", { attrs: { class: "hljs-string" } }, [
                    _vm._v('"errorCollect"')
                  ]),
                  _vm._v("\n              />")
                ]),
                _vm._v("\n          "),
                _c("span", { attrs: { class: "hljs-tag" } }, [
                  _vm._v("</"),
                  _c("span", { attrs: { class: "hljs-name" } }, [
                    _vm._v("div")
                  ]),
                  _vm._v(">")
                ]),
                _vm._v("\n      "),
                _c("span", { attrs: { class: "hljs-tag" } }, [
                  _vm._v("</"),
                  _c("span", { attrs: { class: "hljs-name" } }, [
                    _vm._v("div")
                  ]),
                  _vm._v(">")
                ]),
                _vm._v("\n"),
                _c("span", { attrs: { class: "hljs-tag" } }, [
                  _vm._v("</"),
                  _c("span", { attrs: { class: "hljs-name" } }, [
                    _vm._v("template")
                  ]),
                  _vm._v(">")
                ]),
                _vm._v("\n\n"),
                _c("span", { attrs: { class: "hljs-tag" } }, [
                  _vm._v("<"),
                  _c("span", { attrs: { class: "hljs-name" } }, [
                    _vm._v("script")
                  ]),
                  _vm._v(">")
                ]),
                _c("span", { attrs: { class: "javascript" } }, [
                  _vm._v("\n\n\n  "),
                  _c("span", { attrs: { class: "hljs-keyword" } }, [
                    _vm._v("export")
                  ]),
                  _vm._v(" "),
                  _c("span", { attrs: { class: "hljs-keyword" } }, [
                    _vm._v("default")
                  ]),
                  _vm._v(" {\n   data() {\n      "),
                  _c("span", { attrs: { class: "hljs-keyword" } }, [
                    _vm._v("return")
                  ]),
                  _vm._v(" {\n          "),
                  _c("span", { attrs: { class: "hljs-attr" } }, [
                    _vm._v("form")
                  ]),
                  _vm._v(": {\n              "),
                  _c("span", { attrs: { class: "hljs-attr" } }, [
                    _vm._v("name")
                  ]),
                  _vm._v(": {\n                  "),
                  _c("span", { attrs: { class: "hljs-attr" } }, [
                    _vm._v("label")
                  ]),
                  _vm._v(": "),
                  _c("span", { attrs: { class: "hljs-string" } }, [
                    _vm._v("'姓名'")
                  ]),
                  _vm._v(",\n                  "),
                  _c("span", { attrs: { class: "hljs-attr" } }, [
                    _vm._v("labelKey")
                  ]),
                  _vm._v(": "),
                  _c("span", { attrs: { class: "hljs-string" } }, [
                    _vm._v("'name'")
                  ]),
                  _vm._v(",\n                  "),
                  _c("span", { attrs: { class: "hljs-attr" } }, [
                    _vm._v("placeholder")
                  ]),
                  _vm._v(": "),
                  _c("span", { attrs: { class: "hljs-string" } }, [
                    _vm._v("'请填写真实姓名'")
                  ]),
                  _vm._v(",\n                  "),
                  _c("span", { attrs: { class: "hljs-attr" } }, [
                    _vm._v("value")
                  ]),
                  _vm._v(": "),
                  _c("span", { attrs: { class: "hljs-string" } }, [
                    _vm._v("''")
                  ]),
                  _vm._v(",\n                  "),
                  _c("span", { attrs: { class: "hljs-attr" } }, [
                    _vm._v("required")
                  ]),
                  _vm._v(": "),
                  _c("span", { attrs: { class: "hljs-literal" } }, [
                    _vm._v("true")
                  ]),
                  _vm._v(",\n                  "),
                  _c("span", { attrs: { class: "hljs-attr" } }, [
                    _vm._v("errorStatus")
                  ]),
                  _vm._v(": "),
                  _c("span", { attrs: { class: "hljs-literal" } }, [
                    _vm._v("false")
                  ]),
                  _vm._v(",\n                  "),
                  _c("span", { attrs: { class: "hljs-attr" } }, [
                    _vm._v("valiedateMessage")
                  ]),
                  _vm._v(": "),
                  _c("span", { attrs: { class: "hljs-string" } }, [
                    _vm._v("'输入不能为空'")
                  ]),
                  _vm._v(",\n              },\n              "),
                  _c("span", { attrs: { class: "hljs-attr" } }, [
                    _vm._v("phone")
                  ]),
                  _vm._v(": {\n                  "),
                  _c("span", { attrs: { class: "hljs-attr" } }, [
                    _vm._v("label")
                  ]),
                  _vm._v(": "),
                  _c("span", { attrs: { class: "hljs-string" } }, [
                    _vm._v("'手机号'")
                  ]),
                  _vm._v(",\n                  "),
                  _c("span", { attrs: { class: "hljs-attr" } }, [
                    _vm._v("labelKey")
                  ]),
                  _vm._v(": "),
                  _c("span", { attrs: { class: "hljs-string" } }, [
                    _vm._v("'phone'")
                  ]),
                  _vm._v(",\n                  "),
                  _c("span", { attrs: { class: "hljs-attr" } }, [
                    _vm._v("placeholder")
                  ]),
                  _vm._v(": "),
                  _c("span", { attrs: { class: "hljs-string" } }, [
                    _vm._v("'请填写常用手机号码'")
                  ]),
                  _vm._v(",\n                  "),
                  _c("span", { attrs: { class: "hljs-attr" } }, [
                    _vm._v("value")
                  ]),
                  _vm._v(": "),
                  _c("span", { attrs: { class: "hljs-string" } }, [
                    _vm._v("''")
                  ]),
                  _vm._v(",\n                  "),
                  _c("span", { attrs: { class: "hljs-attr" } }, [
                    _vm._v("required")
                  ]),
                  _vm._v(": "),
                  _c("span", { attrs: { class: "hljs-literal" } }, [
                    _vm._v("true")
                  ]),
                  _vm._v(",\n                  "),
                  _c("span", { attrs: { class: "hljs-attr" } }, [
                    _vm._v("errorStatus")
                  ]),
                  _vm._v(": "),
                  _c("span", { attrs: { class: "hljs-literal" } }, [
                    _vm._v("false")
                  ]),
                  _vm._v(",\n                  "),
                  _c("span", { attrs: { class: "hljs-attr" } }, [
                    _vm._v("valiedateMessage")
                  ]),
                  _vm._v(": "),
                  _c("span", { attrs: { class: "hljs-string" } }, [
                    _vm._v("'输入不能为空'")
                  ]),
                  _vm._v(",\n              },\n              "),
                  _c("span", { attrs: { class: "hljs-attr" } }, [
                    _vm._v("dream")
                  ]),
                  _vm._v(": {\n                  "),
                  _c("span", { attrs: { class: "hljs-attr" } }, [
                    _vm._v("label")
                  ]),
                  _vm._v(": "),
                  _c("span", { attrs: { class: "hljs-string" } }, [
                    _vm._v("'我的梦想'")
                  ]),
                  _vm._v(",\n                  "),
                  _c("span", { attrs: { class: "hljs-attr" } }, [
                    _vm._v("labelKey")
                  ]),
                  _vm._v(": "),
                  _c("span", { attrs: { class: "hljs-string" } }, [
                    _vm._v("'dream'")
                  ]),
                  _vm._v(",\n                  "),
                  _c("span", { attrs: { class: "hljs-attr" } }, [
                    _vm._v("placeholder")
                  ]),
                  _vm._v(": "),
                  _c("span", { attrs: { class: "hljs-string" } }, [
                    _vm._v("'小目标还是要有的，万一平台帮你实现了呢~'")
                  ]),
                  _vm._v(",\n                  "),
                  _c("span", { attrs: { class: "hljs-attr" } }, [
                    _vm._v("value")
                  ]),
                  _vm._v(": "),
                  _c("span", { attrs: { class: "hljs-string" } }, [
                    _vm._v("''")
                  ]),
                  _vm._v(",\n                  "),
                  _c("span", { attrs: { class: "hljs-attr" } }, [
                    _vm._v("required")
                  ]),
                  _vm._v(": "),
                  _c("span", { attrs: { class: "hljs-literal" } }, [
                    _vm._v("true")
                  ]),
                  _vm._v(",\n                  "),
                  _c("span", { attrs: { class: "hljs-attr" } }, [
                    _vm._v("errorStatus")
                  ]),
                  _vm._v(": "),
                  _c("span", { attrs: { class: "hljs-literal" } }, [
                    _vm._v("false")
                  ]),
                  _vm._v(",\n                  "),
                  _c("span", { attrs: { class: "hljs-attr" } }, [
                    _vm._v("valiedateMessage")
                  ]),
                  _vm._v(": "),
                  _c("span", { attrs: { class: "hljs-string" } }, [
                    _vm._v("'输入不能为空'")
                  ]),
                  _vm._v(",\n              },\n              "),
                  _c("span", { attrs: { class: "hljs-attr" } }, [
                    _vm._v("declaration")
                  ]),
                  _vm._v(": {\n                  "),
                  _c("span", { attrs: { class: "hljs-attr" } }, [
                    _vm._v("label")
                  ]),
                  _vm._v(": "),
                  _c("span", { attrs: { class: "hljs-string" } }, [
                    _vm._v("'合伙人宣言'")
                  ]),
                  _vm._v(",\n                  "),
                  _c("span", { attrs: { class: "hljs-attr" } }, [
                    _vm._v("labelKey")
                  ]),
                  _vm._v(": "),
                  _c("span", { attrs: { class: "hljs-string" } }, [
                    _vm._v("'declaration'")
                  ]),
                  _vm._v(",\n                  "),
                  _c("span", { attrs: { class: "hljs-attr" } }, [
                    _vm._v("placeholder")
                  ]),
                  _vm._v(": "),
                  _c("span", { attrs: { class: "hljs-string" } }, [
                    _vm._v("'请介绍一下自己，不少于50字'")
                  ]),
                  _vm._v(",\n                  "),
                  _c("span", { attrs: { class: "hljs-attr" } }, [
                    _vm._v("length")
                  ]),
                  _vm._v(": "),
                  _c("span", { attrs: { class: "hljs-number" } }, [
                    _vm._v("50")
                  ]),
                  _vm._v(",\n                  "),
                  _c("span", { attrs: { class: "hljs-attr" } }, [
                    _vm._v("value")
                  ]),
                  _vm._v(": "),
                  _c("span", { attrs: { class: "hljs-string" } }, [
                    _vm._v("''")
                  ]),
                  _vm._v(",\n                  "),
                  _c("span", { attrs: { class: "hljs-attr" } }, [
                    _vm._v("required")
                  ]),
                  _vm._v(": "),
                  _c("span", { attrs: { class: "hljs-literal" } }, [
                    _vm._v("true")
                  ]),
                  _vm._v(",\n                  "),
                  _c("span", { attrs: { class: "hljs-attr" } }, [
                    _vm._v("errorStatus")
                  ]),
                  _vm._v(": "),
                  _c("span", { attrs: { class: "hljs-literal" } }, [
                    _vm._v("false")
                  ]),
                  _vm._v(",\n                  "),
                  _c("span", { attrs: { class: "hljs-attr" } }, [
                    _vm._v("valiedateMessage")
                  ]),
                  _vm._v(": "),
                  _c("span", { attrs: { class: "hljs-string" } }, [
                    _vm._v("'输入不能为空'")
                  ]),
                  _vm._v(
                    ",\n              },\n          },\n      };\n  },\n  "
                  ),
                  _c("span", { attrs: { class: "hljs-attr" } }, [
                    _vm._v("methods")
                  ]),
                  _vm._v(":{\n     hanleValidate(value) {\n          "),
                  _c("span", { attrs: { class: "hljs-keyword" } }, [
                    _vm._v("if")
                  ]),
                  _vm._v(" (!"),
                  _c("span", { attrs: { class: "hljs-regexp" } }, [
                    _vm._v("/^1[0-9]{10}$/")
                  ]),
                  _vm._v(".test(value)) {\n              "),
                  _c("span", { attrs: { class: "hljs-keyword" } }, [
                    _vm._v("return")
                  ]),
                  _vm._v(" {\n                  "),
                  _c("span", { attrs: { class: "hljs-attr" } }, [
                    _vm._v("validate")
                  ]),
                  _vm._v(": "),
                  _c("span", { attrs: { class: "hljs-literal" } }, [
                    _vm._v("false")
                  ]),
                  _vm._v(",\n                  "),
                  _c("span", { attrs: { class: "hljs-attr" } }, [
                    _vm._v("valiedateMessage")
                  ]),
                  _vm._v(": "),
                  _c("span", { attrs: { class: "hljs-string" } }, [
                    _vm._v("'手机号输入有误！'")
                  ]),
                  _vm._v(",\n              };\n          }\n          "),
                  _c("span", { attrs: { class: "hljs-keyword" } }, [
                    _vm._v("return")
                  ]),
                  _vm._v(" {\n              "),
                  _c("span", { attrs: { class: "hljs-attr" } }, [
                    _vm._v("validate")
                  ]),
                  _vm._v(": "),
                  _c("span", { attrs: { class: "hljs-literal" } }, [
                    _vm._v("true")
                  ]),
                  _vm._v(",\n              "),
                  _c("span", { attrs: { class: "hljs-attr" } }, [
                    _vm._v("valiedateMessage")
                  ]),
                  _vm._v(": "),
                  _c("span", { attrs: { class: "hljs-string" } }, [
                    _vm._v("''")
                  ]),
                  _vm._v(
                    ",\n          };\n      },\n      errorCollect(err, name) {\n          "
                  ),
                  _c("span", { attrs: { class: "hljs-keyword" } }, [
                    _vm._v("this")
                  ]),
                  _vm._v(
                    ".form[name].errorStatus = err;\n      },\n    \tcheck() {\n          "
                  ),
                  _c("span", { attrs: { class: "hljs-built_in" } }, [
                    _vm._v("console")
                  ]),
                  _vm._v(".log("),
                  _c("span", { attrs: { class: "hljs-keyword" } }, [
                    _vm._v("this")
                  ]),
                  _vm._v(".form);\n          "),
                  _c("span", { attrs: { class: "hljs-keyword" } }, [
                    _vm._v("const")
                  ]),
                  _vm._v(" keys = "),
                  _c("span", { attrs: { class: "hljs-built_in" } }, [
                    _vm._v("Object")
                  ]),
                  _vm._v(".keys("),
                  _c("span", { attrs: { class: "hljs-keyword" } }, [
                    _vm._v("this")
                  ]),
                  _vm._v(".form);\n          keys.forEach("),
                  _c("span", { attrs: { class: "hljs-function" } }, [
                    _vm._v("("),
                    _c("span", { attrs: { class: "hljs-params" } }, [
                      _vm._v("item")
                    ]),
                    _vm._v(") =>")
                  ]),
                  _vm._v(" {\n              "),
                  _c("span", { attrs: { class: "hljs-keyword" } }, [
                    _vm._v("if")
                  ]),
                  _vm._v(" (!"),
                  _c("span", { attrs: { class: "hljs-keyword" } }, [
                    _vm._v("this")
                  ]),
                  _vm._v(".form[item].value) {\n                  "),
                  _c("span", { attrs: { class: "hljs-keyword" } }, [
                    _vm._v("this")
                  ]),
                  _vm._v(".form[item].errorStatus = "),
                  _c("span", { attrs: { class: "hljs-literal" } }, [
                    _vm._v("true")
                  ]),
                  _vm._v(";\n                  "),
                  _c("span", { attrs: { class: "hljs-keyword" } }, [
                    _vm._v("this")
                  ]),
                  _vm._v(".form[item].valiedateMessage = "),
                  _c("span", { attrs: { class: "hljs-string" } }, [
                    _vm._v("`"),
                    _c("span", { attrs: { class: "hljs-subst" } }, [
                      _vm._v("${"),
                      _c("span", { attrs: { class: "hljs-keyword" } }, [
                        _vm._v("this")
                      ]),
                      _vm._v(".form[item].label}")
                    ]),
                    _vm._v("输入不能为空`")
                  ]),
                  _vm._v(";\n              }\n          });\n          "),
                  _c("span", { attrs: { class: "hljs-keyword" } }, [
                    _vm._v("if")
                  ]),
                  _vm._v(" (keys.find("),
                  _c("span", { attrs: { class: "hljs-function" } }, [
                    _c("span", { attrs: { class: "hljs-params" } }, [
                      _vm._v("item")
                    ]),
                    _vm._v(" =>")
                  ]),
                  _vm._v(" "),
                  _c("span", { attrs: { class: "hljs-keyword" } }, [
                    _vm._v("this")
                  ]),
                  _vm._v(".form[item].errorStatus === "),
                  _c("span", { attrs: { class: "hljs-literal" } }, [
                    _vm._v("true")
                  ]),
                  _vm._v(")) {\n              "),
                  _c("span", { attrs: { class: "hljs-keyword" } }, [
                    _vm._v("return")
                  ]),
                  _vm._v(";\n          }\n          "),
                  _c("span", { attrs: { class: "hljs-keyword" } }, [
                    _vm._v("this")
                  ]),
                  _vm._v(".submit();\n      },\n  }\n}\n")
                ]),
                _c("span", { attrs: { class: "hljs-tag" } }, [
                  _vm._v("</"),
                  _c("span", { attrs: { class: "hljs-name" } }, [
                    _vm._v("script")
                  ]),
                  _vm._v(">")
                ]),
                _vm._v("\n\n"),
                _c("span", { attrs: { class: "hljs-tag" } }, [
                  _vm._v("<"),
                  _c("span", { attrs: { class: "hljs-name" } }, [
                    _vm._v("style")
                  ]),
                  _vm._v(">")
                ]),
                _c("span", { attrs: { class: "css" } }, [
                  _vm._v("\n"),
                  _c("span", { attrs: { class: "hljs-selector-class" } }, [
                    _vm._v(".form")
                  ]),
                  _vm._v(" {\n  "),
                  _c("span", { attrs: { class: "hljs-attribute" } }, [
                    _vm._v("width")
                  ]),
                  _vm._v(": "),
                  _c("span", { attrs: { class: "hljs-number" } }, [
                    _vm._v("300px")
                  ]),
                  _vm._v(";\n  "),
                  _c("span", { attrs: { class: "hljs-attribute" } }, [
                    _vm._v("font-size")
                  ]),
                  _vm._v(": "),
                  _c("span", { attrs: { class: "hljs-number" } }, [
                    _vm._v("16px")
                  ]),
                  _vm._v(";\n}\n")
                ]),
                _c("span", { attrs: { class: "hljs-tag" } }, [
                  _vm._v("</"),
                  _c("span", { attrs: { class: "hljs-name" } }, [
                    _vm._v("style")
                  ]),
                  _vm._v(">")
                ]),
                _vm._v("\n")
              ])
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c("h3", [_vm._v("注意事项：")]),
      _vm._v(" "),
      _vm._m(3),
      _vm._v(" "),
      _c("h3", [_vm._v("api")]),
      _vm._v(" "),
      _vm._m(4),
      _vm._v(" "),
      _c("h3", [_vm._v("method")]),
      _vm._v(" "),
      _vm._m(5)
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("blockquote", [
      _c("p", [
        _vm._v("textarea 和input的使用方法和传递属性完全一致，故不再赘述。")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("pre", { pre: true }, [
      _c("code", { attrs: { "v-pre": "", class: "language-js" } }, [
        _c("span", { attrs: { class: "hljs-keyword" } }, [_vm._v("import")]),
        _vm._v(" {MiVantInput} "),
        _c("span", { attrs: { class: "hljs-keyword" } }, [_vm._v("from")]),
        _vm._v(" "),
        _c("span", { attrs: { class: "hljs-string" } }, [_vm._v("'miVant'")]),
        _vm._v(";\n"),
        _c("span", { attrs: { class: "hljs-keyword" } }, [_vm._v("const")]),
        _vm._v(" MiVantTextarea = MiVantInput.MiVantTextarea;\n")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", [
      _c("li", [_vm._v("用于创建一个实体或收集信息")]),
      _vm._v(" "),
      _c("li", [_vm._v("需要对输入的数据进行校验")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", [
      _c("li", [_vm._v("input 内置了组件非空的校验，设置required为true即可")]),
      _vm._v(" "),
      _c("li", [_vm._v("内置了输入长度的校验")]),
      _vm._v(" "),
      _c("li", [_vm._v("支持自定义校验等")]),
      _vm._v(" "),
      _c("li", [
        _vm._v("通过fuiTextarea = fuiInput.fuiTextarea 来引入textarea组件")
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v("上面的示例中 需要注意check方法\n"),
        _c("ul", [
          _c("li", [
            _vm._v(
              "校验非空，当用户不触发组件的输入和失焦事件，直接submit的时候 需要增加这样的一条判断"
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "输入组件存在错误的时候，进行提交。  不同于react的函数式组件，在这里 通过getFieldsError，将子组件传递给父组件 进而影响到data中的值，通过对数据进行筛选 可以判断当前是否存在错误"
            )
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("table", [
      _c("thead", [
        _c("tr", [
          _c("th", [_vm._v("属性")]),
          _vm._v(" "),
          _c("th", [_vm._v("说明")]),
          _vm._v(" "),
          _c("th", [_vm._v("类型")]),
          _vm._v(" "),
          _c("th", { staticStyle: { "text-align": "center" } }, [
            _vm._v("默认值")
          ]),
          _vm._v(" "),
          _c("th", [_vm._v("备注")])
        ])
      ]),
      _vm._v(" "),
      _c("tbody", [
        _c("tr", [
          _c("td", [_vm._v("label")]),
          _vm._v(" "),
          _c("td", [_vm._v("对应的label，")]),
          _vm._v(" "),
          _c("td", [_vm._v("String")]),
          _vm._v(" "),
          _c("td", { staticStyle: { "text-align": "center" } }, [_vm._v("''")]),
          _vm._v(" "),
          _c("td", [_vm._v("用于非空校验提示")])
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("td", [_vm._v("labelKey")]),
          _vm._v(" "),
          _c("td", [_vm._v("对应form表单的中的key值")]),
          _vm._v(" "),
          _c("td", [_vm._v("String")]),
          _vm._v(" "),
          _c("td", { staticStyle: { "text-align": "center" } }, [_vm._v("''")]),
          _vm._v(" "),
          _c("td", [_vm._v("父组件收集错误")])
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("td", [_vm._v("value")]),
          _vm._v(" "),
          _c("td", [_vm._v("表单值")]),
          _vm._v(" "),
          _c("td", [_vm._v("String")]),
          _vm._v(" "),
          _c("td", { staticStyle: { "text-align": "center" } }, [_vm._v("''")]),
          _vm._v(" "),
          _c("td")
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("td", [_vm._v("length")]),
          _vm._v(" "),
          _c("td", [_vm._v("输入长度限制")]),
          _vm._v(" "),
          _c("td", [_vm._v("Number")]),
          _vm._v(" "),
          _c("td", { staticStyle: { "text-align": "center" } }, [_vm._v("0")]),
          _vm._v(" "),
          _c("td", [_vm._v("表单失去焦点后校验")])
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("td", [_vm._v("valiedateMessage")]),
          _vm._v(" "),
          _c("td", [_vm._v("自定义错误信息")]),
          _vm._v(" "),
          _c("td", [_vm._v("String")]),
          _vm._v(" "),
          _c("td", { staticStyle: { "text-align": "center" } }, [_vm._v("''")]),
          _vm._v(" "),
          _c("td")
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("td", [_vm._v("type")]),
          _vm._v(" "),
          _c("td", [_vm._v("内置校验组件，idNumber,phone")]),
          _vm._v(" "),
          _c("td", [_vm._v("String")]),
          _vm._v(" "),
          _c("td", { staticStyle: { "text-align": "center" } }, [_vm._v("''")]),
          _vm._v(" "),
          _c("td", [_vm._v("目前有身份证和手机号")])
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("td", [_vm._v("placeholder")]),
          _vm._v(" "),
          _c("td", [_vm._v("value为空的提示文案")]),
          _vm._v(" "),
          _c("td", [_vm._v("String")]),
          _vm._v(" "),
          _c("td", { staticStyle: { "text-align": "center" } }, [_vm._v("''")]),
          _vm._v(" "),
          _c("td")
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("td", [_vm._v("required")]),
          _vm._v(" "),
          _c("td", [_vm._v("组件是否进行非空校验")]),
          _vm._v(" "),
          _c("td", [_vm._v("Boolean")]),
          _vm._v(" "),
          _c("td", { staticStyle: { "text-align": "center" } }, [
            _vm._v("false")
          ]),
          _vm._v(" "),
          _c("td")
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("td", [_vm._v("hanleValidate")]),
          _vm._v(" "),
          _c("td", [_vm._v("传入自定义校验函数")]),
          _vm._v(" "),
          _c("td", [_vm._v("Function")]),
          _vm._v(" "),
          _c("td", { staticStyle: { "text-align": "center" } }, [
            _vm._v("空函数")
          ]),
          _vm._v(" "),
          _c("td")
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("td", [_vm._v("errorStatus")]),
          _vm._v(" "),
          _c("td", [_vm._v("传入错误状态")]),
          _vm._v(" "),
          _c("td", [_vm._v("Boolean")]),
          _vm._v(" "),
          _c("td", { staticStyle: { "text-align": "center" } }, [
            _vm._v("false")
          ]),
          _vm._v(" "),
          _c("td")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("table", [
      _c("thead", [
        _c("tr", [
          _c("th", [_vm._v("方法")]),
          _vm._v(" "),
          _c("th", [_vm._v("说明")]),
          _vm._v(" "),
          _c("th", [_vm._v("类型")])
        ])
      ]),
      _vm._v(" "),
      _c("tbody", [
        _c("tr", [
          _c("td", [_vm._v("blur")]),
          _vm._v(" "),
          _c("td", [
            _vm._v("失去焦点之后触发，对象形式的参数，"),
            _c("br"),
            _vm._v("包含当前组件的value，error状态，labelKey")
          ]),
          _vm._v(" "),
          _c("td", [_vm._v("function")])
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("td", [_vm._v("input")]),
          _vm._v(" "),
          _c("td", [
            _vm._v("v-model指令中包含了 @input的指令"),
            _c("br"),
            _vm._v(
              " v-model的绑定是实时传递组件值的  如果使用value，需要注意父组件中的值"
            )
          ]),
          _vm._v(" "),
          _c("td", [_vm._v("function")])
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("td", [_vm._v("getFieldsError")]),
          _vm._v(" "),
          _c("td", [
            _vm._v(
              "父组件收集子组件内部的错误，输入组件在失去焦点后，会将当前组件的错误状态和labelKey传递给父组件  用于父组件提交时的check"
            )
          ]),
          _vm._v(" "),
          _c("td", [_vm._v("function")])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib!./node_modules/vue-markdown-loader/lib/markdown-compiler.js??ref--1-1!./docs/input.md?vue&type=template&id=fe15094e&
// module id = null
// module chunks = 